import { GetBadgeScript } from '../types';

export const getBadgeScript: GetBadgeScript = () => {
  return `
    <script>
      (function() {
        'use strict';
        
        console.log('[KulpBridge] Badge script loaded');
        
        function createBadge() {
          console.log('[KulpBridge] Creating badge...');
          console.log('[KulpBridge] document.body exists:', !!document.body);
          console.log('[KulpBridge] window.self === window.top:', window.self === window.top);
          
          // Only show badge on normal website, not in iframe
          if (window.self === window.top) {
            console.log('[KulpBridge] Badge will be shown');
            
            // Make sure body exists
            if (!document.body) {
              console.log('[KulpBridge] Body not ready, waiting...');
              setTimeout(createBadge, 50);
              return;
            }
            
            const style = document.createElement('style');
            style.textContent = \`
              .kulp-badge {
                position: fixed !important;
                bottom: 24px !important;
                right: 24px !important;
                background: rgba(20, 20, 30, 0.92) !important;
                color: white !important;
                border-radius: 12px !important;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
                font-size: 13px !important;
                font-weight: 500 !important;
                letter-spacing: -0.01em !important;
                text-decoration: none !important;
                display: flex !important;
                align-items: center !important;
                gap: 10px !important;
                z-index: 2147483647 !important;
                box-shadow: 
                  0 8px 32px rgba(0, 0, 0, 0.12),
                  0 4px 16px rgba(0, 0, 0, 0.08),
                  0 1px 4px rgba(0, 0, 0, 0.06),
                  inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
                transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
                border: 1px solid rgba(255, 255, 255, 0.08) !important;
                backdrop-filter: blur(16px) !important;
                -webkit-backdrop-filter: blur(16px) !important;
                padding: 12px 16px !important;
                pointer-events: auto !important;
                isolation: isolate !important;
                margin: 0 !important;
                max-width: calc(100vw - 48px) !important;
                box-sizing: border-box !important;
                transform: translateY(0) scale(1) !important;
                opacity: 1 !important;
                will-change: transform !important;
                overflow: hidden !important;
              }
              
              .kulp-badge::before {
                content: '' !important;
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                background: linear-gradient(135deg, 
                  rgba(99, 102, 241, 0.1) 0%, 
                  rgba(139, 92, 246, 0.1) 30%,
                  rgba(168, 85, 247, 0.1) 100%) !important;
                border-radius: inherit !important;
                opacity: 0 !important;
                transition: opacity 0.3s ease !important;
                pointer-events: none !important;
              }
              
              .kulp-badge:hover::before {
                opacity: 1 !important;
              }
              
              .kulp-badge * {
                box-sizing: border-box !important;
                pointer-events: auto !important;
              }
              
              .kulp-badge:hover {
                transform: translateY(-3px) scale(1.02) !important;
                box-shadow: 
                  0 16px 48px rgba(0, 0, 0, 0.16),
                  0 8px 24px rgba(0, 0, 0, 0.12),
                  0 2px 8px rgba(0, 0, 0, 0.08),
                  inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
                border-color: rgba(255, 255, 255, 0.12) !important;
                background: rgba(25, 25, 35, 0.94) !important;
              }
              
              .kulp-badge:active {
                transform: translateY(-1px) scale(1.01) !important;
                transition: all 0.15s cubic-bezier(0.16, 1, 0.3, 1) !important;
              }
              
              .kulp-badge .close-btn {
                position: absolute !important;
                top: 4px !important;
                right: 4px !important;
                width: 20px !important;
                height: 20px !important;
                background: rgba(255, 255, 255, 0.08) !important;
                border: 1px solid rgba(255, 255, 255, 0.1) !important;
                border-radius: 6px !important;
                color: rgba(255, 255, 255, 0.7) !important;
                font-size: 12px !important;
                font-weight: 600 !important;
                cursor: pointer !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
                line-height: 1 !important;
                z-index: 2 !important;
                outline: none !important;
                opacity: 0 !important;
                transform: scale(0.8) !important;
                backdrop-filter: blur(8px) !important;
                -webkit-backdrop-filter: blur(8px) !important;
              }
              
              .kulp-badge .close-btn:focus {
                outline: 2px solid rgba(99, 102, 241, 0.5) !important;
                outline-offset: 1px !important;
              }
              
              .kulp-badge:hover .close-btn {
                opacity: 1 !important;
                transform: scale(1) !important;
              }
              
              .kulp-badge .close-btn:hover {
                background: rgba(255, 255, 255, 0.15) !important;
                color: white !important;
                border-color: rgba(255, 255, 255, 0.2) !important;
                transform: scale(1.05) !important;
              }
              
              .kulp-badge .close-btn:active {
                transform: scale(0.95) !important;
                background: rgba(255, 255, 255, 0.12) !important;
              }
              
              .kulp-badge .content {
                display: flex !important;
                align-items: center !important;
                gap: 10px !important;
                flex: 1 !important;
                padding-right: 12px !important;
                position: relative !important;
                z-index: 1 !important;
              }
              
              .kulp-badge .logo {
                width: 22px !important;
                height: 22px !important;
                border-radius: 6px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                flex-shrink: 0 !important;
                overflow: hidden !important;
                background: transparent !important;
                position: relative !important;
              }
              
              .kulp-badge .logo img {
                width: 22px !important;
                height: 22px !important;
                object-fit: contain !important;
                display: block !important;
                border-radius: 6px !important;
                transition: transform 0.2s ease !important;
              }
              
              .kulp-badge:hover .logo img {
                transform: scale(1.05) !important;
              }
              
              .kulp-badge .logo-fallback {
                width: 22px !important;
                height: 22px !important;
                background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 60%, #a855f7 100%) !important;
                border-radius: 6px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                font-size: 11px !important;
                color: white !important;
                font-weight: 700 !important;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
                flex-shrink: 0 !important;
                box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
                transition: transform 0.2s ease !important;
              }
              
              .kulp-badge:hover .logo-fallback {
                transform: scale(1.05) !important;
              }
              
              .kulp-badge .text {
                white-space: nowrap !important;
                opacity: 0.95 !important;
                font-weight: 500 !important;
                position: relative !important;
              }
              
              .kulp-badge .text::after {
                content: '' !important;
                position: absolute !important;
                bottom: -1px !important;
                left: 0 !important;
                width: 0 !important;
                height: 1px !important;
                background: linear-gradient(90deg, #6366f1, #8b5cf6) !important;
                transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
              }
              
              .kulp-badge:hover .text::after {
                width: 100% !important;
              }
              
              /* Mobile responsive design */
              @media (max-width: 768px) {
                .kulp-badge {
                  bottom: 16px !important;
                  right: 16px !important;
                  padding: 10px 14px !important;
                  font-size: 12px !important;
                  border-radius: 10px !important;
                  max-width: calc(100vw - 32px) !important;
                }
                
                .kulp-badge .close-btn {
                  width: 18px !important;
                  height: 18px !important;
                  font-size: 11px !important;
                  top: 3px !important;
                  right: 3px !important;
                }
                
                .kulp-badge .content {
                  gap: 8px !important;
                  padding-right: 10px !important;
                }
                
                .kulp-badge .logo,
                .kulp-badge .logo img,
                .kulp-badge .logo-fallback {
                  width: 18px !important;
                  height: 18px !important;
                }
                
                .kulp-badge .logo-fallback {
                  font-size: 9px !important;
                  border-radius: 5px !important;
                }
              }
              
              /* Reduced motion support */
              @media (prefers-reduced-motion: reduce) {
                .kulp-badge,
                .kulp-badge *,
                .kulp-badge::before {
                  transition: none !important;
                  animation: none !important;
                }
                
                .kulp-badge:hover {
                  transform: none !important;
                }
              }
              
              /* High contrast mode support */
              @media (prefers-contrast: high) {
                .kulp-badge {
                  background: rgba(0, 0, 0, 0.95) !important;
                  border-color: rgba(255, 255, 255, 0.3) !important;
                }
                
                .kulp-badge .close-btn {
                  background: rgba(255, 255, 255, 0.2) !important;
                  border-color: rgba(255, 255, 255, 0.4) !important;
                }
              }
            \`;
            document.head.appendChild(style);

            const badge = document.createElement('a');
            badge.href = 'https://kulp.ai?utm_source=made-with-kulp-chip';
            badge.target = '_blank';
            badge.rel = 'noopener';  // Removed noreferrer to make it dofollow
            badge.className = 'kulp-badge';
            badge.setAttribute('aria-label', 'Made with Kulp');
            badge.setAttribute('title', 'Made with Kulp');  // Added title attribute for better SEO
            badge.setAttribute('data-kulp-badge', 'true');  // Added data attribute for tracking
            
            // Create content container
            const content = document.createElement('div');
            content.className = 'content';
            
            // Create logo container
            const logoContainer = document.createElement('div');
            logoContainer.className = 'logo';
            
            // Try to load the Kulp logo
            const logoImg = document.createElement('img');
            logoImg.src = 'https://kulp.ai/logo.png';
            logoImg.alt = 'Kulp';
            logoImg.loading = 'lazy';
            
            // Create fallback logo
            const logoFallback = document.createElement('div');
            logoFallback.className = 'logo-fallback';
            logoFallback.textContent = 'K';
            logoFallback.style.display = 'none';
            
            // Handle logo load success/failure
            logoImg.onload = function() {
              console.log('[KulpBridge] Logo loaded successfully');
              logoContainer.appendChild(logoImg);
            };
            
            logoImg.onerror = function() {
              console.log('[KulpBridge] Logo failed to load, using fallback');
              logoFallback.style.display = 'flex';
              logoContainer.appendChild(logoFallback);
            };
            
            // Start loading the image
            logoContainer.appendChild(logoImg);
            
            // Create text element
            const textElement = document.createElement('span');
            textElement.className = 'text';
            textElement.textContent = 'Made with Kulp';
            
            // Create close button
            const closeBtn = document.createElement('button');
            closeBtn.className = 'close-btn';
            closeBtn.innerHTML = '×';
            closeBtn.setAttribute('aria-label', 'Dismiss badge');
            closeBtn.title = 'Dismiss';
            
            // Handle close button click
            closeBtn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              // Enhanced fade out animation
              badge.style.transition = 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
              badge.style.transform = 'translateY(20px) scale(0.8)';
              badge.style.opacity = '0';
              badge.style.filter = 'blur(4px)';
              
              setTimeout(function() {
                if (badge.parentNode) {
                  badge.parentNode.removeChild(badge);
                }
              }, 400);
              
              console.log('[KulpBridge] Badge dismissed by user');
            });
            
            content.appendChild(logoContainer);
            content.appendChild(textElement);
            badge.appendChild(content);
            badge.appendChild(closeBtn);
            
            // Add initial animation
            badge.style.transform = 'translateY(20px) scale(0.8)';
            badge.style.opacity = '0';
            document.body.appendChild(badge);
            
            // Trigger entrance animation
            requestAnimationFrame(() => {
              badge.style.transition = 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
              badge.style.transform = 'translateY(0) scale(1)';
              badge.style.opacity = '1';
            });
            
            console.log('[KulpBridge] Badge added to page');
          } else {
            console.log('[KulpBridge] In iframe, badge not shown');
          }
        }
        
        // Wait for DOM to be ready and body to exist
        function waitForBody() {
          if (document.body) {
            createBadge();
          } else {
            setTimeout(waitForBody, 10);
          }
        }
        
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', waitForBody);
        } else {
          waitForBody();
        }
      })();
    </script>
  `;
} 